/* eslint-disable import/prefer-default-export */
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getExtractedPackingListDetails } from "api/services/documentProcessor";
import { GetExtractedPackingListDetailResponseType } from "api/response/documentProcessor";
import { documentProcessorQueryKeys } from "./documentProccessorKeys";

export const useGetExtractedPackingListDetails = (
  id: number,
  options?: UseQueryOptions<GetExtractedPackingListDetailResponseType>,
) =>
  useQuery<GetExtractedPackingListDetailResponseType>({
    queryKey: documentProcessorQueryKeys.extractedPackingListDetail(id),
    queryFn: () => getExtractedPackingListDetails(id).then((res) => res.data),
    ...options,
  });
